/* Rquiere de mixin.js */

var productPriceList = {
	data() {
		return {
			listProductsPriceList: [],
			methodsProductPriceList: {
				get: 'priceLists',
				show: 'priceList/',
				products: '/products'
			},
			paginationProductsPriceList: [],
			searchProductsPriceList: '',
			objectPriceList: {
				id: 0,
				name: ''
			},
			searchingProductPriceList: false
		}
	},
	computed: {
	},
	filters: {
	},
	methods: {
		calculatePrice(quantity, product) {
			let priceList = null
			let currentDate = new Date().getTime();
			if (product.group == 'U') {
				product.price_list.forEach(e => {
					let dateBegin = new Date(e.date_begin).getTime()
					let dateEnd = (e.date_end != null) ? new Date(e.date_end).getTime() : null
					if (dateBegin <= currentDate &&
						e.quantity <= quantity &&
						(dateEnd == null ||
							dateEnd > currentDate)) {
						if (priceList != null) {
							console.log(parseInt(priceList.quantity) < parseInt(e.quantity))
							if (parseInt(priceList.quantity) < parseInt(e.quantity)) {
								priceList = e
							} else if (parseInt(priceList.quantity) == parseInt(e.quantity)) {
								let dateBeginBack = new Date(priceList.date_begin).getTime()
								if (dateBeginBack < dateBegin) {
									priceList = e
								}
							}
						} else {
							priceList = e
						}
					}
				})
			} else if (product.group == 'G') {
				priceList = []
				let index = -1
				product.price_list.forEach(e => {
					let dateBegin = new Date(e.date_begin).getTime()
					let dateEnd = (e.date_end != null) ? new Date(e.date_end).getTime() : null
					console.log(e, dateBegin <= currentDate, e.quantity <= quantity, (dateEnd == null || dateEnd > currentDate))
					if (dateBegin <= currentDate &&
						e.quantity <= quantity &&
						(dateEnd == null ||
							dateEnd > currentDate)) {
						if (priceList == null) {
							priceList.push(e)
						} else {
							index = priceList.map(h => parseInt(h.product_id)).indexOf(parseInt(e.product_id))
							if (index == -1) {
								priceList.push(e)
							} else {
								if ((priceList[index].product_id == e.product_id) && (parseInt(priceList[index].quantity) < parseInt(e.quantity))) {
									priceList.splice(index, 1)
									priceList.push(e)
								} else if ((priceList[index].product_id == e.product_id) && (parseInt(priceList[index].quantity) == parseInt(e.quantity))) {
									let dateBeginBack = new Date(priceList[index].date_begin).getTime()
									if (dateBeginBack < dateBegin) {
										priceList.splice(index, 1)
										priceList.push(e)
									}
								}
							}
						}
					}
				})
				let total = 0
				index = -1
				if (priceList.length > 0) {
					product.product_group.forEach(e => {
						index = priceList.map(h => parseInt(h.product_id)).indexOf(parseInt(e.product_id))
						if (index > -1) {
							total += (priceList[index].price * e.quantity)
						}
					})
				}
				console.log(product.product_group, priceList)
				return total
			}
			return (priceList != null) ? priceList.price : 0
		},
		clearObjectPriceList() {
			this.objectPriceList.id = 0
			this.objectPriceList.name = ''
		},
		getAllProductsPriceList(page = 1) {
			let parameters = '?search=' + this.searchProductsPriceList + '&page=' + page
			this.axiosActionIS(this.getApiBackend + this.methodsProductPriceList.get + parameters, 'GET', 'getAllProductsPriceListResult')
		},
		getAllProductsPriceListResult(response) {
			if (response.data.success) {
				this.listProductsPriceList = response.data.data
				this.paginationProductsPriceList = response.data.paginate
			}
			this.getAllProductsPriceListResultLocal(response)
		},
		getAllProductsPriceListResultLocal(response) {
			console.log('getAllProductsPriceListResultLocal no desarrollado', response)
		},
		getProductPriceList(id, search = '') {
			let param = '?search=' + search
			this.axiosActionIS(this.getApiBackend + this.methodsProductPriceList.show + id + this.methodsProductPriceList.products + param, 'GET', 'getProductPriceListResult')
		},
		getProductPriceListNotTithe(id) {
			this.axiosActionIS(this.getApiBackend + this.methodsProductPriceList.show + id + this.methodsProductPriceList.products + '/notTithe', 'GET', 'getProductPriceListNotTitheResult')
		},
		getProductPriceListResult(response) {
			this.listProductsPriceList = response.data.data
			this.getProductPriceListResultLocal(response)
		},
		getProductPriceListResultLocal(response) {
			console.log('getProductPriceListResultLocal no está desarrollado', response)
		},
		getProductPriceListNotTitheResult(response) {
			this.listProductsPriceListNotTithe = response.data.data
		},
		getProductPriceListNotTitheResultLocal(response) {
			console.log('getProductPriceListNotTitheResultLocal no está desarrollado', response)
		},
		getProductPriceListForBookstoreBilling(priceListId, type = 'CHARACTER', search) {
			this.searchingProductPriceList = true
			let param = '?search=' + search + '&type=' + type
			let url = this.getApiBackend + 'priceList/' + priceListId + '/product' + param
			this.axiosActionIS(url, 'GET', 'getProductPriceListForBookstoreBillingResult')
		},
		getProductPriceListForBookstoreBillingResult(response) {
			this.searchingProductPriceList = false
			if (response.data.success == true) {
				this.listProductsPriceList = response.data.data
			}
			this.getProductPriceListForBookstoreBillingResultLocal(response)
		},
		getProductPriceListForBookstoreBillingResultLocal(response) {
			console.log('getProductPriceListForBookstoreBillingResultLocal no desarrollado', response)
		},
		setObjectPriceList(item) {
			this.clearObjectPriceList()
			let newItem = Object.create(item)
			for (const property in newItem) {
				this.objectPriceList[property] = newItem[property]
			}
		},
	},
};

export default productPriceList;